import type { Mapper } from '@/core/mapper/base-mapper';
import type { GetBeraVersionsResponseDTO } from '@/core/dto/bera';
import type { BeraVersion } from '@/types/Bera';

export class GetBeraVersionsMapper implements Mapper<BeraVersion[]> {
	constructor(private readonly data: GetBeraVersionsResponseDTO) {}

	toDomain(): BeraVersion[] {
		const result = this.data.map(GetBeraVersionsMapper.toVersion);
		return result;
	}

	private static toVersion(row: GetBeraVersionsResponseDTO[number]): BeraVersion {
		const version: BeraVersion = {
			id: row.id,
			tlid_count: row.tlid_count,
			created_at: row.created_at,
			consolidated: row.consolidated,
			is_current: row.is_current
		};
		return version;
	}
}
